import MileagePage from './page';

export default function MileagePreview() {
  return <MileagePage />;
}